import * as angular from "angular";
import * as _ from "lodash";
import {$agentFactory} from "../../agents/$agent.factory";
import {IQService, IRootScopeService} from "angular";

export class AgentMapService {
  $$references: any = {
    agentMarkers: null
  };

  constructor(private $rootScope: IRootScopeService, private $q: IQService, private $agentLocation,
              private $agent: $agentFactory, private mapConstant, private $log) {
  }

  draw(scope, map, agentsIds) {
    const deferred = this.$q.defer(),
      agentMarkersPending = [];

    this.resetReferences(scope);

    _.forEach(agentsIds, (agentId) => {

      const agent = this.$agent(agentId).$value();

      if (_.isUndefined(agent.lastKnownLocation)) {
        this.$log.debug('Agent location resolved to undefined : \n', agent);
      } else {

        const agentMarkerPromise = this.createAgentLocationMarker(scope, map, agentId);
        agentMarkersPending.push(agentMarkerPromise);

      }

    });

    this.$q.all(agentMarkersPending).then(
      (agentMarkers) => {
        this.$$references.agentMarkers = agentMarkers;
        deferred.resolve([agentMarkers]);
      },
      deferred.reject
    );

    return deferred.promise;
  }

  hide() {
    if (this.$$references.agentMarkers) {
      _.forEach(this.$$references.agentMarkers, (agentMarker) => {
        agentMarker.setMap(null);
      });
    }

  }

  show(map) {
    if (this.$$references.agentMarkers) {
      _.forEach(this.$$references.agentMarkers, (agentMarker) => {
        agentMarker.setMap(map);
      });
    }
  }

  getMarkers() {
    if (this.$$references.agentMarkers) {
      return this.$$references.agentMarkers;
    }
    return [];
  }

  // ******************************
  // Internal methods
  // ******************************

  getAgentIcon() {
    const height = 50;
    const width = 50;
    const index = 1;

    return {
      url: 'assets/images/map/driver_markers_vr2.png',
      scaledSize: new google.maps.Size(width * 2, height),
      size: new google.maps.Size(width, height),
      anchor: new google.maps.Point(25, 40),
      zIndex: google.maps.Marker.MAX_ZINDEX,
      origin: new google.maps.Point(index * width, 0)
    };
  }

  resetReferences(scope) {
    if (this.$$references.agentMarkers) {
      _.forEach(this.$$references.agentMarkers, (agentMarker) => {
        _.unset(scope, agentMarker.name);
        agentMarker.setMap(null);
      });
      this.$$references.agentMarkers = null;
    }
  }

  createAgentLocationMarker(scope, map, agentId) {
    const deferred = this.$q.defer();

    this.$agentLocation(agentId).$bind(scope, 'agentLocation_' + agentId).then((agentLocation) => {

        const marker = new google.maps.Marker({
          position: agentLocation.location,
          map: map,
          icon: this.getAgentIcon(),
          zIndex: _.toNumber(google.maps.Marker.MAX_ZINDEX)
        });

        marker.set("id", agentId);
        marker.set("type", 'AgentMarker');
        marker.set("name", 'agentLocation_' + agentId);


        //Bringoz Map - Should delete
        this.$agentLocation(agentId).$registerOnUpdateHandler(scope, (agentLocation) => {
          if (_.isEqual(agentLocation.holderId, agentId)) {
            const latLngPosition = new google.maps.LatLng(agentLocation.coordinates);
            marker.setPosition(latLngPosition);
          }
        });

        this.registerToEvents(marker);

        deferred.resolve(marker);
      },
      deferred.reject
    );

    return deferred.promise;
  }

  registerToEvents(marker) {
    marker.addListener('click', () => {
      this.$rootScope.$broadcast(this.mapConstant.events.agents.select, marker.id);
      this.$rootScope.$applyAsync();
    });
  }
}

angular
  .module('bringoz.admin.map')
  .service('agentMapService', AgentMapService);
